import { useQuery, queryOptions } from '@tanstack/react-query'
import { apiGet } from '@/features/shared/utils/dataFetching'
import { type ViewedElementTrackerResponse } from '@/features/shared/services/ViewedElementTracker/types'
import { useSession } from '@/features/authentication/utils/authentication/hooks/useSession'

export const viewedElementTrackerQueryOptions = queryOptions({
  queryKey: ['viewedElementTracker'] as const,
  queryFn: (context) =>
    apiGet<ViewedElementTrackerResponse>({
      config: {
        url: 'view-tracker/v1/views/',
      },
      fetcherName: 'fetchViewedElementTracker',
      context,
    }),
  staleTime: Infinity,
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
})

export const useQueryViewedElementTracker = () => {
  const { userId } = useSession()
  return useQuery({
    ...viewedElementTrackerQueryOptions,
    enabled: Boolean(userId),
  })
}
